export const ZoomInArea = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="20" cy="20" r="7" stroke="currentColor" stroke-width="2"/>
<path d="M24 19.9945H16" stroke="currentColor" stroke-width="2"/>
<path d="M20 23.9945L20 15.9945" stroke="currentColor" stroke-width="2"/>
<path d="M30.2799 30.29L25.2811 25.2729" stroke="currentColor" stroke-width="2"/>
<path d="M25 8V4C25 3.44772 24.5523 3 24 3H20" stroke="currentColor" stroke-width="2"/>
<path d="M8 3L4 3C3.44771 3 3 3.44772 3 4L3 8" stroke="currentColor" stroke-width="2"/>
<path d="M3 20L3 24C3 24.5523 3.44772 25 4 25L8 25" stroke="currentColor" stroke-width="2"/>
<path d="M3 16V12" stroke="currentColor" stroke-width="2"/>
<path d="M12 3H16" stroke="currentColor" stroke-width="2"/>
</svg>`;
